import React from "react";
import { Table } from "rsuite";

const CustomCell = (props: any) => {
  const { Cell } = Table;
  return <Cell {...props} style={{ padding: 4 }} />;
};

export default CustomCell;
